import { render, staticRenderFns } from "./anulir.vue?vue&type=template&id=1da414dd&"
import script from "./anulir.vue?vue&type=script&lang=js&"
export * from "./anulir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports